import { api } from "./api";

const KEY = "wz_loc_on";
let timer = null;

export const isAutoShare = () => localStorage.getItem(KEY) === "1";

export const sendLocation = (source = "auto") => new Promise((resolve) => {
  if (!navigator.geolocation) return resolve({ ok: false, err: "unsupported" });
  navigator.geolocation.getCurrentPosition(
    async (p) => {
      try { await api.portalLocation({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy, source }); resolve({ ok: true }); }
      catch { resolve({ ok: false, err: "server" }); }
    },
    (e) => resolve({ ok: false, err: e.code === 1 ? "denied" : "unavailable" }),
    { enableHighAccuracy: true, timeout: 20000, maximumAge: 60000 },
  );
});

export const startAutoShare = () => {
  localStorage.setItem(KEY, "1");
  if (timer) return;
  sendLocation("auto");
  timer = setInterval(() => { if (document.visibilityState === "visible") sendLocation("auto"); }, 5 * 60 * 1000);
};

export const stopAutoShare = () => {
  localStorage.removeItem(KEY);
  clearInterval(timer);
  timer = null;
};
